export const FETCH_PROLICY_LIST = `FETCH_PROLICY_LIST_FEATURES`;
export const FETCH_PROLICY_LIST_SUCCESS = `FETCH_PROLICY_LIST_FEATURES_SUCCESS`;
export const FETCH_PROLICY_LIST_FEATURES_FAILURE = `FETCH_PROLICY_LIST_FEATURES_FAILURE`;
export const RESET_PROLICY_LIST = `RESET_PROLICY_LIST`;
export const VHIS_MODAL_DISPLAY = `VHIS_MODAL_DISPLAY`;
